export enum AccessType {
    WEBDESK = 'WEBDESK',
    WEBMOBILE = 'WEBMOBILE',
    NOT_INFORMED = 'NOT_INFORMED',
}

export type LogInfoProps = {
    accessType: AccessType | string
    userAgent: string
    ipAddress: string
    geolocation: string
    accepted: boolean
}

export type LogInfo = {
    logInfo: LogInfoProps
    setLogInfo: (value: LogInfoProps) => void
}
